module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/step1_bg_right-9f2bae953dca711a31a133947d991a2b.png";